import { render, staticRenderFns } from "./AboutVasion.vue?vue&type=template&id=0560c010&scoped=true&"
import script from "./AboutVasion.vue?vue&type=script&lang=js&"
export * from "./AboutVasion.vue?vue&type=script&lang=js&"
import style0 from "./AboutVasion.vue?vue&type=style&index=0&id=0560c010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560c010",
  null
  
)

export default component.exports